import { render, staticRenderFns } from "./WxygTable.vue?vue&type=template&id=80186d54&scoped=true"
import script from "./WxygTable.vue?vue&type=script&lang=js"
export * from "./WxygTable.vue?vue&type=script&lang=js"
import style0 from "./WxygTable.vue?vue&type=style&index=0&id=80186d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80186d54",
  null
  
)

export default component.exports